/**
 * Created by admin on 2017/3/23.
 */
import NProgress from 'nprogress';
import {
    GetParmConfig,
    GetProductClass,
    ParmConfigAdd,
    ParmConfigDel,
    GetProductAttribute
} from '@api/commonApi.js';
import {
    ProductAdd2,
    GetProductById,
    ProductUpdate2
} from '@api/productApi.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import $http from '$http';

module.exports = {
    mounted: function () {
        this.getCategory();
        this.getClass();
        this.getSelectList("6");
        this.getSelectList("7");
        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {
            this.$store.dispatch("getRouterName", "修改单品")
            this.Update = true;
            let para = {
                Sid: this.$route.query.Sid,
                Session: this.$route.query.Session,
                Id: this.$route.query.Id
            };
            GetProductById(para).then(res => {
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.Form = Data;
                    this.activenaturalUnits = this.Form.ProNaturalUnit;
                    this.activesaleUnits = this.Form.ProSaleUnit;
                    if (this.$route.query.view == "true") {
                        this.$store.dispatch("getRouterName", "查看单品")
                        this.isEdit = false;
                        this.Upload = false;
                    }
                });
            });
        } else {
            this.$store.dispatch("getRouterName", "新增商品")
        }
        //  util.uploadPicture(this,this.flag);
    },
    data() {
        return {
            flag: "1",
            logining: false,
            Upload: true,
            isEdit: true,
            Update: false,
            Session: util.getSessin(),
            naturalUnits: [], //自然单位
            saleUnits: [], //销售单位
            ProTypeNames: [], //类型
            StockTypeNames: MAP_LIST.STOCKTYPE_NAME, //仓库类型
            ProSubjectionNames: MAP_LIST.INTENT_PROJECT, //项目
            activenaturalUnits: "",
            activesaleUnits: "",
            Form: {
                ProTypeId: "",
                ProTypeName: "",
                ProSubjection: "",
                ProSubjectionName: "",
                ProName: "",
                ProNick: "",
                ProCode: "",
                ProProportion1: "",
                ProProportion2: "",
                ProNaturalUnit: "",
                ProSaleUnit: "",
                ProRemark: "",
                StockType: "",
                StockTypeName: ""
            },
            visibleShow: false,
            table: {},
            dialogContent: "",
            PictureVisible: false,
            dialogImageUrl: ""
        }
    },
    watch: {
        activenaturalUnits: function () {
            if (this.activenaturalUnits !== 0) {
                this.Form.ProNaturalUnit = this.naturalUnits.find(item => item.Id == this.activenaturalUnits).ParmName;
            }
        },
        activesaleUnits: function () {
            if (this.activesaleUnits !== 0) {
                this.Form.ProSaleUnit = this.saleUnits.find(item => item.Id == this.activesaleUnits).ParmName
            }
        },
    },
    methods: {
        getCategory() {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: 12
            };
            GetParmConfig(Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.ProTypeNames = Data;
                });
            });
        },
        submit() {

            if (this.isEdit) {
                //util.getItemByIdInArr(this.Form.ProSubjectionName, this.ProSubjectionNames, 'name').id
                let params = Object.assign({}, this.Form, {
                    "ProNaturalUnit": this.activenaturalUnits, //自然单位
                    "ProSaleUnit": this.activesaleUnits //销售单位
                });

                if (this.Update == false) {
                    ProductAdd2(params).then(res => {
                        util.doResult(this, res, () => {
                            this.$notify({
                                title: '成功',
                                message: '添加成功',
                                type: 'success'
                            });
                            this.$router.push('/productInformation/otherProduct');
                        });
                    })
                } else {
                    params.ProductId = this.$route.query.Id;
                    ProductUpdate2(params).then(res => {
                        util.doResult(this, res, () => {
                            this.$notify({
                                title: '成功',
                                message: '更新成功',
                                type: 'success'
                            });
                            this.$router.push({
                                path: '/productInformation/otherProduct',
                                query: {
                                    'reload': true
                                }
                            });
                        });
                    })
                }
            } else {
                this.$router.push({
                    path: '/productInformation/otherProduct',
                    query: {
                        'reload': true
                    }
                });
            }

        },
        mydialog(type) {
            if (type == 6) {
                this.table = {
                    title: "自然单位管理",
                    data: this.naturalUnits,
                    label: "自然单位",
                    type: 6
                };
            };
            if (type == 7) {
                this.table = {
                    title: "销售单位管理",
                    data: this.saleUnits,
                    label: "销售单位",
                    type: 7
                };
            };
            this.visibleShow = true;
        },
        delTable(index, item, type) {
            let para = {
                Ids: item.Id
            };
            ParmConfigDel(para).then(res => {
                util.doResult(this, res, () => {
                    this.getSelectList(type);
                    this.activeSelect(type, item.Id)
                })
            });
        },
        addDialog(type) {
            var para = {
                ParmType: type,
                ParmName: this.dialogContent
            };
            ParmConfigAdd(para).then(res => {
                util.doResult(this, res, () => {
                    this.dialogContent = "";
                    this.visibleShow = false;
                    this.getSelectList(type, "1");
                })
            });
        },

        getClass() {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1]
            };
            GetProductClass(Params).then(res => {
                util.doResult(this, res, () => {
                    this.Class = res.data.Data;
                })
            });
            GetProductAttribute(Params).then(res => {
                util.doResult(this, res, () => {
                    this.Attribute = res.data.Data;
                })
            });
        },
        activeSelect(type, Id) {
            if (type == 6) {
                for (var i = 0; i < this.naturalUnits.length; i++) {
                    if (this.naturalUnits[i].Id == Id) {
                        this.Form.ProNaturalUnit = "";
                        this.activenaturalUnits = "";
                    }
                }
            };
            if (type == 7) {
                for (var i = 0; i < this.saleUnits.length; i++) {
                    if (this.saleUnits[i].Id == Id) {
                        this.Form.ProSaleUnit = "";
                        this.activesaleUnits = "";
                    }
                }
            };
        },
        getSelectList(type, isAdd) {
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                ParmType: type
            };
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 6) {
                        this.naturalUnits = res.data.Data;
                        this.table.data = this.naturalUnits;

                    };
                    if (type == 7) {
                        this.saleUnits = res.data.Data;
                        this.table.data = this.saleUnits;
                    };
                    if (isAdd == 1) {
                        if (type == 6) {
                            this.activenaturalUnits = this.naturalUnits[this.naturalUnits.length - 1].Id;
                            for (var i = 0; i < this.naturalUnits.length; i++) {
                                if (this.naturalUnits[i].Id == this.activenaturalUnits) {
                                    this.Form.ProNaturalUnit = this.naturalUnits[i].ParmName
                                }
                            }
                        };
                        if (type == 7) {
                            this.activesaleUnits = this.saleUnits[this.saleUnits.length - 1].Id;
                            for (var i = 0; i < this.saleUnits.length; i++) {
                                if (this.saleUnits[i].Id == this.activesaleUnits) {
                                    this.Form.ProSaleUnit = this.saleUnits[i].ParmName
                                }
                            }
                        };
                    }
                })
            });
        },
        dialogClosed() {
            this.dialogContent = "";
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/productInformation/ProductAdd.js